import React from 'react';
import { Card, Grid, styled } from '@mui/material';
import { ChevronRightRounded } from '@mui/icons-material';
import { Colors, Text } from 'library';

export function ScheduleACall({ small }: { small: boolean }) {
    return (
        <Container small={small}>
            <Hyperlink href="https://meetings.hubspot.com/joy-gupit" target="_blank" rel="noreferrer">
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <Text variant="body2" bold textStyle={{ color: Colors.white }}>
                            Have questions?
                        </Text>
                        <Text variant="body2" textStyle={{ color: Colors.white }}>
                            Schedule a call with Tandem
                        </Text>
                    </Grid>
                    <ChevronRightRounded htmlColor="inherit" style={{ height: 28, width: 28, color: Colors.white }} />
                </Grid>
            </Hyperlink>
        </Container>
    );
}

const Container = styled(Card)(({ small }: { small: boolean }) => ({
    padding: '5px 10px',
    backgroundColor: Colors.turquoise,
    borderRadius: 10,
    width: small === false ? 300 : undefined,
    marginLeft: small === false ? 10 : undefined,
    display: small === false ? 'inline-flex' : 'flex',
}));

const Hyperlink = styled('a')({
    width: '100%',
    '&:hover': {
        textDecoration: 'none',
    },
});
